import React from "react";

const FilterData = ({
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search...",
  selectConfigs = [], // [{ label, value, options, onChange }]
}) => {
  return (
    <div className="filters d-flex gap-3 mb-3">
      {/* Search */}
      <input
        type="text"
        className="form-control"
        placeholder={searchPlaceholder}
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
      />

      {/* Dynamic Selects */}
      {selectConfigs.map((select, idx) => (
        <select
          key={idx}
          className="form-select"
          value={select.value}
          onChange={(e) => select.onChange(e.target.value)}
        >
          <option value="">{select.label}</option>
          {select.options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ))}
    </div>
  );
};

export default FilterData;
